import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.clear-secondary-category-report-access.UseClearSecondaryCategoryReportAccessPresenter`

export default defineMessages({
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage: 'Something went wrong. Please try again.',
  },
})
